import page from 'page'

import appStarterPg from '../../../config/app-starter-pg.js'
import { browserAppUser } from '../../../helpers/app-data-loaders/app-user.js'
import { browserAppAccount } from '../../../helpers/app-data-loaders/app-account.js'
import { contentElementId } from '../../../config/config.js'
import { showPageWhatHasBeenDonePg } from './journals-what-been-done-pg/index.js'
import { showPageMonthlyAnalysisPG } from './monthly-analysis-pg/index.js'

/**
 * /app/financials/...
 */
export function setupAnalysisRoutes (baseRoute) {
  /**
   * /financials/analysis/:appAccountId/what-has-been-done
   */
  page(`${baseRoute}/:appAccountId/what-has-been-done`, async function (context) {
    const { appAccountId } = context.params
    await appStarterPg({
      appAccountId,
      includeEntities: true,
      includeCurrencies: true
    })

    showPageWhatHasBeenDonePg({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount
    })
  })

  /**
   * /financials/analysis/:appAccountId/:analysisType
   * /financials/analysis/:appAccountId/topExpenses
   * /financials/analysis/:appAccountId/newExpenses
   * /financials/analysis/:appAccountId/endedExpenses
   * /financials/analysis/:appAccountId/topRevenue
   * /financials/analysis/:appAccountId/newRevenue
   * /financials/analysis/:appAccountId/endedRevenue
   * /financials/analysis/:appAccountId/allPnl
   */
  page(`${baseRoute}/:appAccountId/:analysisType`, async function (context) {
    const { appAccountId, analysisType } = context.params

    await appStarterPg({
      appAccountId,
      includeEntities: true,
      includeCurrencies: true
    })

    showPageMonthlyAnalysisPG({
      containerElementId: contentElementId,
      browserAppUser,
      browserAppAccount,
      analysisType
    })
  })
}
